:host {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}

:host(.copied) es-icon {
    color: var(--color-success);
}
:host(.failed) es-icon {
    color: var(--color-error);
}

es-icon {
    margin-left: 14px;
}
